import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (props, ref) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}><path fill="#707781" d="M15.536 7.05l1.414 1.415-8.485 8.485-1.414-1.414z" /><path fill="#707781" d="M8.464 7.05l8.486 8.485-1.415 1.414L7.05 8.464z" /></svg>;
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;